import axiosInstance from './api'
import TokenService from './tokenService'
import Vue from 'vue'
import {eventBus} from "../main";

const setup = (store, router) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = TokenService.getLocalAccessToken()
      if (config.url.includes("hooks.slack")) {
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
      } else {
        if (token) {
          config.headers['Authorization'] = 'Bearer ' + token
        }
        // if (config.url.includes("sentry")) {
        //   config.headers['Authorization'] = 'DSN https://075617cb2b04c22851064e17c31d0f92@o493491.ingest.us.sentry.io/4507049700687872'
        // }
      }
      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  axiosInstance.interceptors.response.use(
    (res) => {
      return res
    },
    async (err) => {
      const originalConfig = err.config

      // Refresh Token expired
      if ((err.response.status === 403 || err.response.status === 401) && originalConfig.url === '/oauth/access_token') {
        await store.dispatch('LogOut')
        router.push('/login')
      } else if (originalConfig.url !== '/api/login' && originalConfig.url !== '/forgotPassword/resetPassword' && originalConfig.url !== '/oauth/access_token' && err.response) {
        // Access Token expired
        if (err.response.status === 401 && !originalConfig._retry) {
          originalConfig._retry = true

          try {
            TokenService.removeLocalAccessToken()
            const params = new URLSearchParams()
            params.append('grant_type', 'refresh_token')
            params.append('refresh_token', TokenService.getLocalRefreshToken())

            const res = await axiosInstance({
              method: 'POST',
              url: '/oauth/access_token',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              },
              data: params
            })

            store.dispatch('refreshToken', res)

            return axiosInstance(originalConfig)
          } catch (_error) {
            return Promise.reject(_error)
          }
        } else if (err.response.status === 500 || err.response.status === 404 || err.response.status === 400 || (err.response.status === 403 && !err.response.data.isFieldError) && !(originalConfig.url == '/authentication/validateAccountCode' && err.response.data.message == 'token.invalid.error')) {
          const vm = new Vue()
          //TODO à voir si on met aussi un lien dans le texte du toast pour signaler le bug ? rediriger vers la page de signalement peut-être ?
          const message = a('div', {}, [
            'Veuillez réessayer ultérieurement. Si l\'erreur persiste, merci de  ',
            a('a', {
              attrs: {
                href: "#"
              },
              on: {
                click: (event) => {
                  if (['preproduction', 'production'].includes(process.env.NODE_ENV)) {
                    eventBus.$emit('showBugReportModal');
                  }
                }
              }
            }, 'signaler ce bug')
          ]);


          vm.$bvToast.toast(message, {
            title: "Une erreur s'est produite.",
            autoHideDelay: 20000,
            toaster: 'b-toaster-bottom-right',
          })
        }
      }

      return Promise.reject(err)
    }
  )
}

export default setup



// WEBPACK FOOTER //
// ./src/services/setupInterceptors.js